export default __webpack_public_path__ + "static/media/Game.61922259.svg";